var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgThemeDarkIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6354 12.7165C17.3271 12.6498 18.0687 13.6331 17.6271 14.2581C17.3604 14.6331 17.0771 14.9831 16.7271 15.3165C13.4688 18.5914 8.19375 18.5914 4.94375 15.3165C1.68542 12.0665 1.68542 6.78312 4.94375 3.53312C5.27708 3.19978 5.62708 2.89978 6.00208 2.63312C6.62708 2.19145 7.61042 2.93312 7.54375 3.62478C7.31875 6.00812 8.11875 8.48312 9.95208 10.3081C11.7771 12.1415 14.2437 12.9415 16.6354 12.7165ZM15.2688 14.3998C12.9104 14.2664 10.5771 13.2915 8.76875 11.5081C6.96042 9.68312 5.99375 7.34145 5.86042 4.99145C3.51875 7.60812 3.61042 11.6248 6.11875 14.1415C8.63542 16.6498 12.6521 16.7415 15.2688 14.3998Z",
    fill: "#EBEBF5",
    fillOpacity: 0.6
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThemeDarkIcon);
export default __webpack_public_path__ + "static/media/theme-dark-icon.e0ab23858da2bd97fd131a994f0bc412.svg";
export { ForwardRef as ReactComponent };